<template>
  <base-modal
    id="CreateCommunication"
    title="Add a message"
    :show="showModal"
    @closed="showModal = false"
  >
    <vue-editor
      id="editor"
      ref="editor"
      v-model="content"
      :editor-options="editorSettings"
    />

    <template slot="footer">
      <base-button
        :disabled="content == ''"
        inverse
        @click="sendMessage"
      >
        Add Message
      </base-button>
    </template>
  </base-modal>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { mapActions } from 'vuex';

export default {
  components: {
    VueEditor,
  },
  data() {
    return {
      showModal: false,
      content: '',
      editorSettings: {
        formats: [
          'background',
          'bold',
          'color',
          'font',
          'code',
          'italic',
          'link',
          'size',
          'strike',
          // 'script',
          'underline',
          'blockquote',
          'header',
          'indent',
          'list',
          'align',
          'direction',
          'code-block',
          'font',
          'hashtag',
          // 'image'
          // 'video'
        ],
        modules: {
          toolbar: {
            // container: "#customToolbar",
            container: [
              ['link', 'bold', 'italic', 'underline'],
              // [{ 'align': ''},{ 'align': 'center'}, { 'align': 'right' }],
              [{ size: ['small', false, 'large', 'huge'] }],
            ],
            handlers: {
              addTag: () => {
                this.addCustomTag('Name');
              },
            },
          },
        },
      },
    };
  },
  methods: {
    ...mapActions('messages', ['newItem']),
    open() {
      this.showModal = true;
    },
    sendMessage() {
      this.newItem({ message: this.content })
        .then((ms) => {
          this.content = '';
          this.$emit('messageCreated', ms.data);
        });
      setTimeout(() => {
        this.showModal = false;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
